import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import AUX from '../../hoc/AU-X/AU-X';
import { logout } from '../../store/index';

const folders = ['AddInvidualData', 'UploadData', 'GetData', 'UserManager'];

const UploadDetails = (props) => {
  const dispatch = useDispatch();

  return (
    <AUX>
      <div className='homePage'>
        <div className='healthDays' style={{ gridTemplateColumns: '1fr 1fr' }}>
          {folders.map((element) => (
            <NavLink key={element} to={`/${element}`}>
              {element}
            </NavLink>
          ))}
        </div>
      </div>
      <div className='logout' onClick={() => dispatch(logout())}>
        logout
      </div>
    </AUX>
  );
};

export default UploadDetails;
